import { render, staticRenderFns } from "./zhihui.vue?vue&type=template&id=8cf93322&scoped=true"
import script from "./zhihui.vue?vue&type=script&lang=js"
export * from "./zhihui.vue?vue&type=script&lang=js"
import style0 from "./zhihui.vue?vue&type=style&index=0&id=8cf93322&prod&lang=scss"
import style1 from "./zhihui.vue?vue&type=style&index=1&id=8cf93322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf93322",
  null
  
)

export default component.exports